// ============================================================
// systems/phase4.js — Phase 4: The Void (6000+ clicks)
// ============================================================
import { state } from '../state.js';
import { dom } from '../dom.js';
import { startVoidMusic, stopVoidMusic } from '../audio/musicVoid.js';
import { playVoidEntrySound } from '../audio/sfx.js';
import { registerDeactivator } from './bombs.js';

export function activatePhase4() {
  if (state.phase4Active) return;
  state.phase4Active = true;

  // Warning
  dom.phase4Warning.classList.add('show');
  setTimeout(() => dom.phase4Warning.classList.remove('show'), 3500);

  // Grey mode
  document.body.classList.add('phase4-mode');

  // Swap plushie back to phase 1 version but greyed
  const plushieImg = dom.smiley.querySelector('img');
  if (state.originalPlushieSrc) {
    plushieImg.src = state.originalPlushieSrc;
  }
  dom.smiley.classList.remove('abstracted');
  dom.smiley.classList.add('greyed');

  // Stop phase 3 audio
  dom.phase3Audio.pause();

  // Start void music (if music enabled)
  if (dom.toggleMusic.classList.contains('on')) {
    startVoidMusic();
  }

  // Entry sound
  playVoidEntrySound();
}

export function deactivatePhase4() {
  if (!state.phase4Active) return;
  state.phase4Active = false;
  document.body.classList.remove('phase4-mode');
  dom.smiley.classList.remove('greyed');
  stopVoidMusic();

  // Restore to phase 3 abstracted if still >= 3500
  if (state.phase3Active) {
    // Don't swap the character image — keep the current plushie and
    // re-apply the abstracted tint/glitch via the class.
    const randomHue = Math.floor(Math.random() * 360);
    dom.smiley.style.setProperty('--abs-hue', randomHue + 'deg');
    dom.smiley.classList.add('abstracted');
  }
}

// Register phase4 deactivator so bombs.js can call it without circular import
registerDeactivator('phase4', deactivatePhase4);
